import { LearningPath, LearningPathProgress, Content } from '../../types'

interface LearningPathsState {
  learningPaths: Array<LearningPath>
  currentLearningPath: LearningPath
  currentProgress: LearningPathProgress
  nextContent: Content | object
}

const state: LearningPathsState = {
  learningPaths: [],
  currentLearningPath: {},
  currentProgress: {},
  nextContent: {},
}

export { LearningPathsState, state }
